import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Buyer } from 'src/app/core/buyers.service';

@Component({
  selector: 'app-buyers-onboarding-dialog',
  templateUrl: './buyers-onboarding-dialog.component.html',
  styleUrls: ['./buyers-onboarding-dialog.component.scss'],
})
export class BuyersOnboardingDialogComponent {
  buyer?: Buyer;

  constructor(private dialog_ref: MatDialogRef<BuyersOnboardingDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    this.buyer = data.buyer;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  getOnboardingSteps(): string[][] {
    if (!this.buyer?.on_boarding_steps) return [];
    return this.getCronologicalOnboardingSteps(Object.entries(this.buyer?.on_boarding_steps));
  }

  getCronologicalOnboardingSteps(onboarding_steps: string[][]): string[][] {
    return onboarding_steps
      ?.sort((a: string[], b: string[]) => {
        return a[1] && b[1] ? +b[1] - +a[1] : 0;
      })
      .reverse();
  }
}
